import { request, requestForm } from '../../Common/api/client';

const BASE_PATH = '/api/cp/gasystem/terminal-import';

export async function getGasystemTerminalImportCapability() {
  return request({ method: 'GET', url: `${BASE_PATH}/capability` });
}

export async function previewGasystemTerminalImport(file) {
  const data = new FormData();
  data.append('file', file);
  return requestForm({ method: 'POST', url: `${BASE_PATH}/preview`, data });
}

export async function getGasystemTerminalImportBatches(params = {}) {
  return request({ method: 'GET', url: `${BASE_PATH}/batches`, params });
}

export async function getGasystemTerminalImportBatch(batchId, params = {}) {
  return request({ method: 'GET', url: `${BASE_PATH}/batches/${encodeURIComponent(batchId)}`, params });
}

export async function applyGasystemTerminalImportBatch(batchId) {
  return request({ method: 'POST', url: `${BASE_PATH}/batches/${encodeURIComponent(batchId)}/apply` });
}
